import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import type { AppProfile, AppRole } from "../types";

export default function AdminUsers() {
  const [profiles, setProfiles] = useState<AppProfile[]>([]);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState("");

  async function load() {
    const { data, error: queryError } = await supabase
      .from("app_profiles")
      .select("user_id,email,full_name,role,is_active")
      .order("email");

    if (queryError) setError(queryError.message);
    else setProfiles((data ?? []) as AppProfile[]);
  }

  useEffect(() => {
    void load();
  }, []);

  async function patch(userId: string, values: Partial<Pick<AppProfile, "role" | "is_active">>) {
    setBusyId(userId);
    setError("");
    const { error: updateError } = await supabase
      .from("app_profiles")
      .update(values)
      .eq("user_id", userId);

    if (updateError) setError(updateError.message);
    else await load();
    setBusyId("");
  }

  return (
    <section className="stack-xl">
      <header className="page-header">
        <div>
          <p className="eyebrow">Administração</p>
          <h2>Acessos</h2>
          <p className="muted">
            Novos utilizadores começam inativos. Um administrador tem de os ativar
            explicitamente.
          </p>
        </div>
      </header>

      {error ? <div className="alert alert-error">{error}</div> : null}

      <div className="table-card card">
        <div className="admin-table admin-table-head">
          <span>Utilizador</span>
          <span>Perfil</span>
          <span>Estado</span>
        </div>

        {profiles.map((profile) => (
          <div className="admin-table" key={profile.user_id}>
            <div>
              <strong>{profile.full_name || profile.email || "Sem nome"}</strong>
              {profile.full_name && profile.email ? (
                <small className="muted">{profile.email}</small>
              ) : null}
            </div>

            <select
              value={profile.role}
              disabled={busyId === profile.user_id}
              onChange={(event) =>
                void patch(profile.user_id, { role: event.target.value as AppRole })
              }
            >
              <option value="viewer">Consulta</option>
              <option value="estimator">Orçamentista</option>
              <option value="admin">Administrador</option>
            </select>

            <button
              className={profile.is_active ? "button button-secondary" : "button button-primary"}
              disabled={busyId === profile.user_id}
              onClick={() => void patch(profile.user_id, { is_active: !profile.is_active })}
            >
              {profile.is_active ? "Desativar" : "Ativar"}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
